$('.filter-trigger').on('click', function(e) {
    $('.filter-trigger').toggleClass('filter-trigger--active');
    $('.search-page').toggleClass('filter-trigger-active');
    $('.gpn-search__container-block-radio').slideToggle();
})

$(window).on('resize', removeStyleAttr);

function removeStyleAttr() {
    if ($(window).width() > 768) {
        $('.gpn-search__container-block-radio').prop('style', null);
    }
}


// WEBPACK FOOTER //
// ./frontend/components/search-page/search-page.js